// import ShareButton from '../../../../../bower_components/share-button/share-button';
import ShareButton from '../../lib/share-button/share-button';
import 'rrssb';
import $ from 'jquery';

$(document).ready(function () {
    // var config = {
    //     ui: {
    //         flyout: 'bottom center',
    //         buttonText: 'Partager <i class="icon-share"></i>'
    //     },
    //     networks: {
    //         pinterest: {
    //             enabled: false
    //         },
    //         twitter: {
    //             enabled: true
    //         },
    //         facebook: {
    //             enabled: true
    //         },
    //         googlePlus: {
    //             enabled: false
    //         },
    //         reddit: {
    //             enabled: false
    //         },
    //         linkedin: {
    //             enabled: false
    //         },
    //         email: {
    //             enabled: true
    //         }
    //     }
    // };
    //
    // var shareButton = new ShareButton('.share-button', config);

    let titleArticle = $('h1').html().trim(),
        urlArticle = window.location.href;

    $('.rrssb-buttons').rrssb({
        // required:
        title: titleArticle,
        url: urlArticle,
        description: titleArticle,
    });
    $('.btn-rrssb').click(function (){
        $('.rrssb-buttons').toggleClass('active');
    });
});
